import PropTypes from "prop-types";
import "@/styles/index.scss";

import "../i18n";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "@/redux/store";
import { initializeGA } from "@/helpers/analytics";
import { useEffect, useState } from "react";
import ErrorBoundary from "@/components/core/error-boundary";
import Authorize from "@/components/core/authorize";
import Loader from "@/components/core/loader";
import Head from "next/head";
import Layout from "@/components/core/layout";
import theme from "../helpers/theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import MuiErrorModal from "@/components/core/material-ui/mui-error-modal";
import { IMAGE_BASE_PATH } from "@/config/config";
import Script from "next/script";
import logger from "@/helpers/logger";

export default function App({ Component, pageProps }) {
  useEffect(() => {
    initializeGA();
    // pageView("RETAIL_HEALTH");
  }, []);
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Head>
          <meta name="description" content="Retail Health - Elder Care" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <link rel="icon" href={`${IMAGE_BASE_PATH}/bolt-new-logo.svg`} />
          <title>{"Bolt Quick Quote"}</title>
        </Head>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <ErrorBoundary>
            <Authorize>
              <Layout>
                <Loader />
                <MuiErrorModal />
                <Script
                  src="https://www.google.com/recaptcha/api.js?render=explicit"
                  async
                  defer
                  onLoad={() => logger.log("reCAPTCHA script loaded!")}
                />
                <Component {...pageProps} />
              </Layout>
            </Authorize>
          </ErrorBoundary>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
}

App.propTypes = {
  Component: PropTypes.any,
  pageProps: PropTypes.any,
};
